import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Button } from "./shared/Button";
import { useI18n } from "../../i18n/I18nProvider"; // adjust path if needed

interface CompletionStepProps {
  onNext: () => void;
}

export function CompletionStep({ onNext }: CompletionStepProps) {
  const { t } = useI18n();

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center space-y-16 relative">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.2, ease: [0.25, 0.1, 0.25, 1] }}
        className="relative"
      >
        <div className="w-48 h-48 rounded-full animated-gradient-circle flex items-center justify-center organic-shadow">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6, duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <Check className="w-20 h-20 text-white stroke-[1.5] relative z-10" />
          </motion.div>
        </div>
      </motion.div>

      <div className="space-y-8 max-w-2xl mx-auto">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 1.2, ease: [0.25, 0.1, 0.25, 1] }}
          className="text-5xl sm:text-6xl font-normal text-[#2D2A35] tracking-tight"
        >
          {t("completion.title")}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 1.2, ease: [0.25, 0.1, 0.25, 1] }}
          className="text-xl sm:text-2xl text-[#57534E] leading-relaxed font-light"
        >
          {t("completion.body")}
        </motion.p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 1.2, ease: [0.25, 0.1, 0.25, 1] }}
        className="w-full max-w-xs pt-12"
      >
        <Button onClick={onNext} fullWidth className="text-lg py-6">
          {t("completion.cta")}
        </Button>
      </motion.div>
    </div>
  );
}